import { Button, Col, Form, Row, Spinner } from "react-bootstrap";

const RouteForm = ({
  form,
  validationErrors,
  submitting,
  submitLabel = "Save Route",
  submittingLabel = "Saving...",
  readOnly = false,
  imageFile,
  existingImage,
  onSubmit,
  onFieldChange,
  onImageChange,
  onBack,
}) => {
  const disabled = submitting || readOnly;

  return (
    <Form onSubmit={onSubmit}>
      <h5 className="mb-3 mt-2">Basic Information</h5>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>
              Title <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="text"
              value={form.title}
              onChange={(e) => onFieldChange("title", e.target.value)}
              placeholder="Desert Loop"
              isInvalid={!!validationErrors.title}
              disabled={disabled}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.title}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>
              Total Distance (km) <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              type="number"
              min="0"
              step="0.1"
              value={form.total_distance_km}
              onChange={(e) => onFieldChange("total_distance_km", e.target.value)}
              placeholder="120"
              isInvalid={!!validationErrors.total_distance_km}
              disabled={disabled}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.total_distance_km}
            </Form.Control.Feedback>
          </Form.Group>
        </Col>

        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Estimated Time</Form.Label>
            <Form.Control
              type="text"
              value={form.estimated_time}
              onChange={(e) => onFieldChange("estimated_time", e.target.value)}
              placeholder="3-5 Hours"
              disabled={disabled}
            />
          </Form.Group>
        </Col>

        <Col md={12}>
          <Form.Group className="mb-3">
            <Form.Label>Description</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              value={form.description}
              onChange={(e) => onFieldChange("description", e.target.value)}
              placeholder="Main rally track"
              disabled={disabled}
            />
          </Form.Group>
        </Col>
      </Row>

      <h5 className="mb-3 mt-2">Track Map</h5>
      <Row>
        <Col md={6}>
          <Form.Group className="mb-3">
            <Form.Label>Track Map Image</Form.Label>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e) => onImageChange(e.target.files?.[0] || null)}
              disabled={disabled}
              isInvalid={!!validationErrors.track_map_image}
            />
            <Form.Control.Feedback type="invalid">
              {validationErrors.track_map_image}
            </Form.Control.Feedback>
            <Form.Text className="text-muted">Optional</Form.Text>
          </Form.Group>
        </Col>
      </Row>

      <div className="d-flex justify-content-end gap-2 mt-3">
        <Button type="button" variant="outline-secondary" onClick={onBack} disabled={submitting}>
          Cancel
        </Button>
        <Button type="submit" disabled={disabled}>
          {submitting ? (
            <>
              <Spinner animation="border" size="sm" className="me-2" />
              {submittingLabel}
            </>
          ) : (
            submitLabel
          )}
        </Button>
      </div>
    </Form>
  );
};

export default RouteForm;

